<template>
  <div>
    <div id="category-wrapper" v-if="currentCategory && currentCategory.type !== 'wfs_folder'">
      <div id="category-header" v-if="currentCategory.parent">
        <button id="arrow" @click="chooseCategory(currentCategory.parent)">
          <i v-if="!$root.$data.embedded" class="material-icons-round">arrow_back_ios</i>
          {{ cleanCategoryName(currentCategory.name) }}
          <span v-if="collapsed && !$root.$data.embedded">({{ childCount(currentCategory) }})</span>
        </button>
        <div class="actions">
          <div v-if="canPinCurrent" class="pin" @click="togglePin(currentCategory)">
          <!-- <div v-if="hasItems && !$root.$data.embedded" class="pin" @click="togglePin(currentCategory)"> -->
            <i class="material-icons-round" :class="{pinned: isPinned}" title="pin">push_pin</i>
          </div>
          <div class="collapse" @click="collapsed = !collapsed">
            <i class="material-icons-round" :class="{collapsed: collapsed}" title="collapse">keyboard_arrow_down</i>
          </div>
        </div>
      </div>
      <div id="chosen-category" v-if="pinnedCategories.length > 0">
        <div v-for="category in pinnedCategories" :key="category.id" class="chosen-single-cat">
          <div class="chosen-inner-cat">
            <div class="chosen-category-name">{{ cleanCategoryName(category.name) }}  ({{ childCount(category) }})</div>
            <a class="close-button" @click="togglePin(category)" v-if="!$root.$data.embedded">Remove</a>
          </div>
        </div>
      </div>
      <div class="category-grid-wrapper" v-if="!collapsed">
        <div
         :class="[
          'category-grid',
          pinnedCategories.length > 0
            ? 'one-column'
            : (
                currentCategory.parent
                  ? 'one-column'
                  : (
                      currentCategory.children.length <= 1
                        ? 'one-column'
                        : 'two-columns'
                    )
              )
        ]"

        >
        <!-- <div :class="['category-grid', currentCategory.parent ? 'one-column' : 'two-columns']"> -->
          <div
            v-for="item in [...currentCategory.children, ...pinnedChildren]"
            :key="item.id"
            class="category-container" 
          >
            <div
              v-if="['folder', 'wfs_folder'].includes(item.type) && !$root.$data.embedded"
              class="category"
              @click="chooseCategory(item)"
              :style="getStyle(item)"
            >
              <!-- <img v-if="item.image" :src="hostAddress + item.image" alt="" /> -->
              <!-- <img v-else src="/images/placeholder.png" alt="" /> -->
              <!-- <img class="cover-logo" v-if="poiData.logo" :src="hostAddress + poiData.logo" alt="logo" /> -->
              <button
                v-if="['folder', 'wfs_folder'].includes(item.type) && !$root.$data.embedded"
                class="category no-bg"
                @click="chooseCategory(item)"
                :style="getStyle(item)"
              >
                <div class="category-box no-bg" >
                  <img v-if="item.logo" :src="hostAddress + item.logo" alt="" />
                  <div class="category-name"  v-html="item.name"  :lang="bcp47Locale"></div>
                </div>
              </button>

              <div class="category-box">
                <img v-if="item.logo" :src="hostAddress + item.logo" alt="" />
                <div class="category-name"  v-html="item.name"  :lang="bcp47Locale"></div>
              </div>
            </div>
            <PoiTocCard v-if="item.type === 'item' && item.name" :item="item" />
          </div>
        </div>
      </div>
    </div>
    <WfsFolder
  v-if="currentCategory && currentCategory.type === 'wfs_folder'"
  :category="currentCategory"
  @return="handleReturnFromWfs"
/>
<!-- 
    <WfsFolder
      v-if="currentCategory && currentCategory.type === 'wfs_folder'"
      v-bind:category="currentCategory"
      @return="chooseCategory(currentCategory.parent)"
    ></WfsFolder> -->
  </div>
</template>
<script>
import PoiTocCard from "./PoiTocCard";
import M2wApi from "@/services/m2w_api";
import WfsFolder from "@/components/category_components/WfsFolder";
import convertPoisToGeoJSON from "@/convertPoisToGeoJSON";
// import maplibregl from "maplibre-gl";
import {googleMaps} from "@/services/map/googleMaps";
import {basemap} from "@/services/map/basemap";
// import { hyphenateCategoryTree } from "@/translations/hyphenation";



export default {
  name: "CategoriesFrame",
  components: {WfsFolder, PoiTocCard },
  data() {
    return {
      hostAddress: M2wApi.host_address,
      categoryTree: null,
      currentCategory: null,
      pinnedCategories: [],
      collapsed: this.$root.$data.embedded,
    };
  },

  async mounted() {
    await this.fetchFromApi();
    this.$root.$on("forceCategoryReloadFor3D", this.reloadCategoryFor3D);
    this.$root.$on("poiSelectedFrom3D", this.selectCategoryFrom3D);
  },
  activated() {
    // activated is also called on mounted (without waiting for async)
    // so this check prevents activated from firing when mounted is already underway
    if (this.categoryTree) {
      this.onActivated();
    }
  },
  // deactivated() {
  //   if (this.currentCategory) this.$layers.teardownCategory(this.currentCategory);
  //   for (let cat of this.pinnedCategories) this.$layers.teardownCategory(cat);
  // },

  deactivated() {
  
  if (this.currentCategory) {
    const curIsPinned = this.pinnedCategories.some(c => String(c.id) === String(this.currentCategory.id));
    if (!curIsPinned) this.$layers.teardownCategory(this.currentCategory);
  }

},

  beforeDestroy() {
    this.$root.$off("forceCategoryReloadFor3D", this.reloadCategoryFor3D);
    this.$root.$off("poiSelectedFrom3D", this.selectCategoryFrom3D); // curățare
  },

  computed: {
    bcp47Locale() {
    const map = { en: 'en-US', de: 'de', hu: 'hu', ro: 'ro' };
    return map[this.$i18n.locale] || 'en-US';
  },

    pinnedChildren: function () {
      let distinctChildren = this.distinct(
        this.pinnedCategories
          .map((cat) => cat.children)
          .flat()
          .filter((child) => child.type === "item"),
        (item) => item.id,
      );
      return distinctChildren.filter((c) => !this.currentCategory.children.find((cc) => c.id === cc.id));
    },
    hasItems: function () {
      return this.currentCategory.children.some((child) => child.type === "item");
    },
    isPinned: function () {
      return this.pinnedCategories.includes(this.currentCategory);
    },
    canPinCurrent() {
      return !this.$root.$data.embedded && !!this.currentCategory?.parent;
    },
  },

  watch: {
    pinnedCategories: async function (newValues, oldValues) {
      for (let cat of newValues) {
        if (!oldValues.includes(cat)) {
          await this.$layers.setupCategory(cat, this.goToPoi);
        }
      }
      const queryValue = newValues.map(c => c.id).join(',');
      if (this.$route.query.pinned !== queryValue) {
        await this.$router.push({ query: { ...this.$route.query, pinned: queryValue } });
      }
    },
    
    "$i18n.locale": async function () {
      await this.fetchFromApi();
    },
  },


  methods: {
    cleanCategoryName(name) {
      if (!name) return "";
      return name.replace(/&shy;|\u00AD/g, "");
    },
      isService(cat) {
      return cat && cat.type !== 'wfs_folder' && (!Array.isArray(cat.children) || cat.children.length === 0);
    },
    findItemById(node, idWanted) {
      if (!node) return null;
      const want = String(idWanted);
      if (String(node.id) === want) return node;
      if (Array.isArray(node.children)) {
        for (const ch of node.children) {
          const hit = this.findItemById(ch, want);
          if (hit) return hit;
        }
      }
      return null;
    },
    async selectCategoryFrom3D(feature) {
      const TAG = "[CategoriesFrame] selectCategoryFrom3D";
      console.groupCollapsed(`${TAG} ▶ start`);
      try {
        console.log(`${TAG} raw feature:`, feature);
        const g = feature?.geometry;
        console.log(`${TAG} geom:`, {
          type: g?.type,
          hasCoords: !!g?.coordinates,
          coordsLen:
            Array.isArray(g?.coordinates)
              ? g.coordinates.length
              : (Array.isArray(g?.coordinates?.[0])
                  ? g.coordinates[0].length
                  : undefined)
        });
        console.log(`${TAG} properties(keys):`, Object.keys(feature?.properties || {}));
        const rawId = feature?.properties?.id ?? feature?.id ?? "";
        const id = String(rawId || "");
        console.log(`${TAG} extracted id:`, { rawId, id, typeofRawId: typeof rawId });
        if (!id) {
          console.warn(`${TAG} Fără id pe feature → ies`);
          console.groupEnd();
          return;
        }

        const item = this.findItemById(this.categoryTree, id);
        console.log(`${TAG} item găsit în categoryTree:`, item);
        const parentCandidates = {
          fromItem: item?.parent?.id ?? null,
          fromFeatureProp: feature?.properties?.parent_id ?? null,
          fromCurrentCategory: this.currentCategory?.id ?? null,
          fromRouteQuery: this.$route?.query?.parent ?? null,
        };
        const parentId =
          parentCandidates.fromItem ??
          parentCandidates.fromFeatureProp ??
          parentCandidates.fromCurrentCategory ??
          parentCandidates.fromRouteQuery ??
          null;

        console.log(`${TAG} parent candidates:`, parentCandidates);
        console.log(`${TAG} parentId ales:`, parentId);

        const target = {
          name: "poiDetails",
          params: { id },
          query: { ...this.$route.query, parent: parentId }
        };
        console.log(`${TAG} target route:`, target);
        console.log(`${TAG} current route:`, {
          name: this.$route.name,
          params: this.$route.params,
          query: this.$route.query
        });

        const samePage =
          this.$route.name === target.name &&
          String(this.$route.params.id ?? "") === String(target.params.id ?? "") &&
          String(this.$route.query.parent ?? "") === String(target.query.parent ?? "");
        console.log(`${TAG} samePage?`, samePage);

        if (!samePage) {
          try {
            await this.$router.push(target);
            console.log(`${TAG} router.push OK`);
          } catch (err) {
            if (err?.name === "NavigationDuplicated") {
              console.log(`${TAG} router.push NavigationDuplicated (ignorat)`);
            } else {
              console.warn(`${TAG} router.push error:`, err);
            }
          }
        } else {
          console.log(`${TAG} suntem deja pe ruta țintă → nu navighez`);
        }

        // this.$root.$refs.weatherMtk?.focusOnPoi?.(feature);

      } catch (e) {
        console.warn(`${TAG} failed:`, e);
      } finally {
        console.groupEnd();
      }
    }
    ,
    categoryHasPois(cat) {
      if (!cat || !Array.isArray(cat.children)) return false;
      return cat.children.some(el => {
        const geom = typeof el.geom === "function" ? el.geom() : el.geom;
        const coords = geom?.coordinates || (Array.isArray(geom) ? geom : null);
        return Array.isArray(coords) && coords.length > 0;
      });
    },

    restoreInitialMapView() {
      try {
        const saved = sessionStorage.getItem("initialView");
        if (!saved) return;
        const { lat, lng, zoom } = JSON.parse(saved);

        const view = basemap.map.getView();
        view.setCenter(googleMaps.transformFromLatLng({ lat, lng }));
        if (typeof zoom === "number") view.setZoom(zoom);
      } catch (e) {
        console.warn("[CategoriesFrame] initialView invalid:", e);
        sessionStorage.removeItem("initialView");
      }
    }, 
    async handleReturnFromWfs() {
      const parent = this.currentCategory?.parent;
      if (!parent) return;

      const goingToRoot = !parent.parent;
      console.log(goingToRoot, "layers Cristina")

      await this.chooseCategory(parent);

      if (goingToRoot) {
        this.restoreInitialMapView();
      }
    },
    async fetchFromApi() {
      this.$Progress.start();
      this.categoryTree = await M2wApi.get_project_pois(this.$i18n.locale);
      let data = await M2wApi.get_project_pois(this.$i18n.locale);
      console.log('[DB] get_project_pois ->', data); 

    //  hyphenateCategoryTree(data, this.$i18n.locale);
      
      this.categoryTree = data;
      // walking through the category tree to add back links
      this.linkChildren(this.categoryTree);
      await this.onActivated();
      this.$Progress.finish();
    },

    async chooseCategory(category) {
      if (this.$root.$data.embedded) return;

      this.collapsed = false;
      if (category.name && category.name.includes("href=")) {
        const href = category.name.match(/href="(.+?)"/)[1];
        console.log(href)
        window.open(href);
        return;
      }
      

      if (this.isService(category)) {
      if (!this.pinnedCategories.some(c => String(c.id) === String(category.id))) {
          this.$root.$emit('armClose3D'); 
          this.$root.$emit('armServiceForCategory', { catId: category.id });
          this.togglePin(category); 
        }
        return; 
      }
      const goingToRoot = !category?.parent;

      await this.updateCurrentCategory(category, this.currentCategory);

      if (goingToRoot) {
        this.restoreInitialMapView();
        this.$root.$emit("clearAll3D");
      }
    },
    
    // async updateCurrentCategory(category, oldCategory) {
    //   if (this.$root.showMap3D && this.$root.$refs.map3d?.getCurrentView) {
    //     this.savedCamera3D = this.$root.$refs.map3d.getCurrentView();
    //   }
    //   this.currentCategory = category;

    //   if (oldCategory && !this.pinnedCategories.includes(oldCategory)) {
    //     this.$layers.teardownCategory(oldCategory);
    //   }
    //   const rawChildren = category.children || [];
    //   console.log(rawChildren);

    //   const pois = rawChildren
    //     .map((el) => {
    //       const geom = typeof el.geom === "function" ? el.geom() : el.geom;
    //       const coords = geom?.coordinates || (Array.isArray(geom) ? geom : null);

    //       if (!coords || !Array.isArray(coords)) return null;

    //       return {
    //         id: el.id,
    //         name: el.name,
    //         type: el.type,
    //         parent_id: el.parent?.id,
    //         geom: coords,
    //         height: el.height,
    //         style: el.style,
    //         icon: el.icon
    //           ? this.hostAddress + el.icon
    //           : el.marker
    //             ? this.hostAddress + el.marker
    //             : el.parent?.marker
    //               ? this.hostAddress + el.parent.marker
    //               : null,

    //         icon_id: el.icon
    //           ? el.icon.split("/").pop()
    //           : el.marker
    //             ? el.marker.split("/").pop()
    //             : el.parent?.marker
    //               ? el.parent.marker.split("/").pop()
    //               : null,

    //         width: el.width,
    //         color: el.color,
    //         line_color: el.line_color,
    //         line_thickness: el.line_thickness,
    //       };
    //     })
    //     .filter(Boolean);

    //   const willHavePois = pois.length > 0;
    //   if (!willHavePois) {
    //     console.log("[3D→OL] folder fără POI-uri → armClose3D");
    //     this.$root.$emit("armClose3D");
    //     this.$root.$emit('armServiceForCategory', { catId: category.id });
    //   }

    //   await this.$layers.setupCategory(category, this.goToPoi);
    //   // const geojsonPois = convertPoisToGeoJSON(pois);
    //   // console.log('[DB->MAP] geojsonPois ->', geojsonPois);
    //   // this.loadedFeatures = geojsonPois.features;
    //   // this.lastPoisJSON = JSON.stringify(geojsonPois);
    //   // this.$root.$emit("poisLoaded", geojsonPois);
    //   // console.log("Sending POIs to maps", geojsonPois);
    //   // this.$root.$emit("focusPois", geojsonPois);
    //   // console.log("Focus POIs to maps", geojsonPois);

    //   this.emitPoisForMaps();

    //   if (oldCategory && this.savedCamera3D && this.$root.weatherMtk) {
    //     this.$nextTick(() => {
    //       setTimeout(() => {
    //         console.log("Restoring previous 3D camera:", this.savedCamera3D);
    //         this.$root.$refs.weatherMtk.map.flyTo({
    //           center: [this.savedCamera3D.lng, this.savedCamera3D.lat],
    //           zoom: this.savedCamera3D.zoom,
    //           bearing: this.savedCamera3D.bearing || 0,
    //           pitch: this.savedCamera3D.pitch || 0,
    //           speed: 0.6,
    //           curve: 1.1,
    //         });
    //       }, 200);
    //     });
    //   }

    //   this.$emit("showHeader", category.name === null);
    //   if (!category.id && this.$route.query["toc-id"]) {
    //     const {["toc-id"]: _, ...filtered} = this.$route.query;
    //     await this.$router.push({query: filtered});
    //   }
    //   if (
    //     category.id &&
    //     (!this.$route.query["toc-id"] || this.$route.query["toc-id"].toString() !== category.id.toString())
    //   ) {
    //     await this.$router.push({query: {...this.$route.query, "toc-id": category.id}});
    //   }
    // },

    async updateCurrentCategory(category, oldCategory) {
      if (oldCategory) {
        const oldWasPinned = this.pinnedCategories.some(
          c => String(c.id) === String(oldCategory.id)
        );

        const oldHadPois = this.categoryHasPois(oldCategory); 

        if (!oldWasPinned && !oldHadPois && oldCategory.id != null) {
          console.log(
            "[CategoriesFrame] back din categorie fără POI-uri → deactivateServiceForCategory",
            oldCategory.id
          );
          this.$root.$emit("deactivateServiceForCategory", { cat: oldCategory });
        }
      }

      if (this.$root.showMap3D && this.$root.$refs.map3d?.getCurrentView) {
        this.savedCamera3D = this.$root.$refs.map3d.getCurrentView();
      }
      this.currentCategory = category;

      if (oldCategory && !this.pinnedCategories.includes(oldCategory)) {
        this.$layers.teardownCategory(oldCategory);
      }
      const rawChildren = category.children || [];
      console.log(rawChildren);

      const pois = rawChildren
        .map((el) => {
          const geom = typeof el.geom === "function" ? el.geom() : el.geom;
          const coords = geom?.coordinates || (Array.isArray(geom) ? geom : null);

          if (!coords || !Array.isArray(coords)) return null;

          return {
            id: el.id,
            name: el.name,
            type: el.type,
            parent_id: el.parent?.id,
            geom: coords,
            height: el.height,
            style: el.style,
            icon: el.icon
              ? this.hostAddress + el.icon
              : el.marker
                ? this.hostAddress + el.marker
                : el.parent?.marker
                  ? this.hostAddress + el.parent.marker
                  : null,

            icon_id: el.icon
              ? el.icon.split("/").pop()
              : el.marker
                ? el.marker.split("/").pop()
                : el.parent?.marker
                  ? el.parent.marker.split("/").pop()
                  : null,

            width: el.width,
            color: el.color,
            line_color: el.line_color,
            line_thickness: el.line_thickness,
          
          };
        })
        .filter(Boolean);

      const willHavePois = pois.length > 0;
      if (!willHavePois) {
        console.log("[3D→OL] folder fără POI-uri → armClose3D");
        this.$root.$emit("armClose3D");
        this.$root.$emit("armServiceForCategory", { catId: category.id });
      }

      await this.$layers.setupCategory(category, this.goToPoi);

      this.emitPoisForMaps();

      if (oldCategory && this.savedCamera3D && this.$root.weatherMtk) {
        this.$nextTick(() => {
          setTimeout(() => {
            console.log("Restoring previous 3D camera:", this.savedCamera3D);
            this.$root.$refs.weatherMtk.map.flyTo({
              center: [this.savedCamera3D.lng, this.savedCamera3D.lat],
              zoom: this.savedCamera3D.zoom,
              bearing: this.savedCamera3D.bearing || 0,
              pitch: this.savedCamera3D.pitch || 0,
              speed: 0.6,
              curve: 1.1,
            });
          }, 200);
        });
      }

      this.$emit("showHeader", category.name === null);
      if (!category.id && this.$route.query["toc-id"]) {
        const { ["toc-id"]: _, ...filtered } = this.$route.query;
        await this.$router.push({ query: filtered });
      }
      if (
        category.id &&
        (!this.$route.query["toc-id"] ||
          this.$route.query["toc-id"].toString() !== category.id.toString())
      ) {
        await this.$router.push({
          query: { ...this.$route.query, "toc-id": category.id },
        });
      }
    },
    async onActivated() {
      this.currentCategory = this.findCurrentCategory();
      await this.updateCurrentCategory(this.currentCategory, null);

      this.pinnedCategories = this.findPinnedCategories();
    },

    buildPoisFromCategories(categories) {
      const rawChildren = categories
        .filter(Boolean)
        .map(cat => cat.children || [])
        .flat();

      const pois = rawChildren
        .map((el) => {
          const geomObj = (typeof el.geom === "function") ? el.geom() : el.geom; // ✅ definit aici

          if (!geomObj || !geomObj.type || !geomObj.coordinates) return null;
          // const geom = typeof el.geom === "function" ? el.geom() : el.geom;
          // const coords = geom?.coordinates || (Array.isArray(geom) ? geom : null);

          // if (!coords || !Array.isArray(coords)) return null;

          return {
            id: el.id,
            name: el.name,
            type: el.type,
            parent_id: el.parent?.id,
            // geom: coords,
            geom: {          
              type: geomObj.type,
              coordinates: geomObj.coordinates
            },
            height: el.height,
            style: el.style,
            icon: el.icon
              ? this.hostAddress + el.icon
              : el.marker
                ? this.hostAddress + el.marker
                : el.parent?.marker
                  ? this.hostAddress + el.parent.marker
                  : null,

            icon_id: el.icon
              ? el.icon.split("/").pop()
              : el.marker
                ? el.marker.split("/").pop()
                : el.parent?.marker
                  ? el.parent.marker.split("/").pop()
                  : null,

            width: el.width,
            color: el.color,
            line_color: el.line_color,
            line_thickness: el.line_thickness,
          
          };
        })
        .filter(Boolean);
      const seen = new Set();
      return pois.filter(p => {
        if (seen.has(p.id)) return false;
        seen.add(p.id);
        return true;
      });
    },

    emitPoisForMaps() {
      const categories = [this.currentCategory, ...this.pinnedCategories];

      const pois = this.buildPoisFromCategories(categories);
      const geojsonPois = convertPoisToGeoJSON(pois);

      console.log('[DB->MAP] geojsonPois (all cats+pins) ->', geojsonPois);
      this.loadedFeatures = geojsonPois.features;
      this.lastPoisJSON = JSON.stringify(geojsonPois);

      this.$root.$emit("poisLoaded", geojsonPois);
      this.$root.$emit("focusPois", geojsonPois);
    },
    emitPoisForMapsNoFly() {
      const categories = [this.currentCategory, ...this.pinnedCategories];

      const pois = this.buildPoisFromCategories(categories);
      const geojsonPois = convertPoisToGeoJSON(pois);

      console.log('[DB->MAP] geojsonPois (all cats+pins) ->', geojsonPois);
      this.loadedFeatures = geojsonPois.features;
      this.lastPoisJSON = JSON.stringify(geojsonPois);

      this.$root.$emit("poisLoaded", geojsonPois);
    },

    togglePin(category) {
      const wasPinned = this.pinnedCategories.some(
        c => String(c.id) === String(category.id)
      );

      if (wasPinned) {
        // REMOVE
        this.pinnedCategories = this.pinnedCategories.filter(
          c => String(c.id) !== String(category.id)
        );
        this.$layers.teardownCategory(category);
        this.$root.$emit('deactivateServiceForCategory', { cat: category });
        if (this.currentCategory?.id === category.id && category.parent) {
          this.chooseCategory(category.parent);
        }
      } else {
        // ADD
        if (this.isService(category)) {
          this.$root.$emit('armClose3D');
          this.$root.$emit('armServiceForCategory', { catId: category.id });
        }
        this.pinnedCategories = [...this.pinnedCategories, category];
        this.$layers.setupCategory(category, this.goToPoi); 
      }

      this.emitPoisForMapsNoFly();
    },
    


    // togglePin(category) {
    //   const wasPinned = this.pinnedCategories.some(c => String(c.id) === String(category.id));

    //   if (wasPinned) {
    //     // REMOVE
    //     this.pinnedCategories = this.pinnedCategories.filter(c => String(c.id) !== String(category.id));
    //     this.$layers.teardownCategory(category);
    //     this.$root.$emit('deactivateServiceForCategory', { cat: category });
    //     if (this.currentCategory?.id === category.id && category.parent) this.chooseCategory(category.parent);
    //   } else {
    //     // ADD
    //     if (this.isService(category)) {
    //       this.$root.$emit('armClose3D');
    //       this.$root.$emit('armServiceForCategory', { catId: category.id });
    //     }
    //     this.pinnedCategories = [...this.pinnedCategories, category];
    //     this.$layers.setupCategory(category, this.goToPoi); 
    //   }
    // },

    linkChildren(category) {
      if (category.children) {
        for (let child of category.children) {
          child["parent"] = category;
          this.linkChildren(child);
        }
      }
    },

    findCurrentCategory() {
      let catId = this.$route.query["toc-id"];
      if (catId && !isNaN(catId)) {
        let cat = this.findCategory(this.categoryTree, parseInt(catId));
        if (cat) return cat;
      }
      return this.categoryTree;
    },

    findCategory(node, catId) {
      if (node.id === catId) return node;
      if (node.children) {
        for (let child of node.children) {
          let hit = this.findCategory(child, catId);
          if (hit) return hit;
        }
      }
      return null;
    },

    findPinnedCategories() {
      let catIds = this.$route.query["pinned"];
      if (!catIds) return [];

      let split = catIds.split(",");
      return split
        .map((chunk) => chunk.trim())
        .filter((chunk) => !isNaN(chunk))
        .map((chunk) => parseInt(chunk))
        .filter((v, i, a) => a.indexOf(v) === i) // distinct
        .map((id) => this.findCategory(this.categoryTree, id));
    },

    distinct(arr, func) {
      let tmp = {};
      return arr.filter(function (entry) {
        let key = func(entry);
        if (tmp[key]) {
          return false;
        }
        tmp[key] = true;
        return true;
      });
    },

    async goToPoi(poi) {
       if (poi.name)
        // ex. bus lines should not be clickable
        await this.$router.push({
          name: "poiDetails",
          params: {id: poi.id},
          query: {...this.$route.query, parent: poi.parent.id}
        });
          console.log("goTOPOI cand dau click pe harta ol se aplica ");
      // if (!poi?.geom) return;
    },

    childCount(cat) {
      return cat.children.filter((c) => c.type === "item").length;
    },
    getStyle(category) {
      if (category.style && category.style.fill_color) {
        return {background: category.style.fill_color};
      }
      return "";
    },
    reloadCategoryFor3D() {
      if (this.currentCategory) {
        this.updateCurrentCategory(this.currentCategory, null);
      }
    },
    // beforeDestroy() {
    //   this.$root.$off("forceCategoryReloadFor3D", this.reloadCategoryFor3D);
    // }
    
  },
};
</script>

